import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function Handson(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '0px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2 style={{whiteSpace:'normal'}}>Hands-on Electronics</h2>
                <li>
                    <Link to={`${url}/safety`}>Safety</Link>
                </li>
                <li>
                    <Link to={`${url}/circuits`}>Constructing Circuits</Link>
                </li>
                <li>
                    <Link to={`${url}/soldering`}>Soldering</Link>
                </li>    
                <li>
                    <Link to={`${url}/multimeters`}>Multimeters</Link>
                </li>
                <li>
                    <Link to={`${url}/oscilloscopes`}>Oscilloscopes</Link>
                </li>    
                <li>
                    <Link to={`${url}/symbols`}>Electrical Symbols</Link>
                </li> 
                <li>
                    <Link to={`${url}/shielding`}>Electrical Shielding</Link>
                </li>          
                <li>
                    <Link to={`${url}/electricaltools`}>Electrical Tools</Link>
                </li>       
                          
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default Handson; 